



 export const imager = {
     family : require('../assets/family.jpg'),
     bigFamily : require('../assets/big-family.jpg'),
     dadaMama : require('../assets/old-big-family.jpg'),
     kairat: "https://vesti.kz/userdata/news/news_277532/crop_b/photo_141462.jpg",
     one: require('../assets/old-one.jpg'),
     kazakh: require('../assets/kazakh.webp'),
     lailash: require('../assets/lailash.jpg'),
     laura: require('../assets/laura.jpeg'),
     abay: require('../assets/abay.jpeg'),
     mama: require('../assets/mama.jpeg'),
     dana: require('../assets/dana.jpeg'),
     kuz: require('../assets/kuz.jpeg'),
     karga: require('../assets/karga.jpeg'),
     zulpikar: require('../assets/zulpikar.jpeg')
    };